import {
  SubjectContainerUsageDocument,
  SubjectContainerUsageQuery,
  SubjectContainerUsageQueryVariables,
  SubjectContainerUsedInLessonsDocument,
  SubjectContainerUsedInLessonsQuery,
  SubjectContainerUsedInLessonsQueryVariables,
} from '../../../types/planung-graphql-client-defs';
import { urqlClient } from '../../../utils/urqlClient';
import { SubjectContainerUsedInDataType } from '../components/SubjectContainerUsedIn';

/**
 * Prüft vor dem Löschen, ob eine der Schienen verwendet wird, und liefert die erste verwendete samt
 * ihrer Zuordnungen für den Hinweis. `null` heißt: keine ist verwendet, das Löschen kann laufen.
 * Das Backend prüft dasselbe noch einmal und lehnt sonst mit DELETE_BLOCKED ab.
 */
export const loadSubjectContainerUsedIn = async (uuids: string[]): Promise<SubjectContainerUsedInDataType | null> => {
  const { data } = await urqlClient
    .query<SubjectContainerUsageQuery, SubjectContainerUsageQueryVariables>(
      SubjectContainerUsageDocument,
      { uuids },
      { requestPolicy: 'network-only' },
    )
    .toPromise();

  const used = data?.subjectContainerUsage.find(
    (usage) =>
      usage.lessonsCount > 0 || usage.curriculaCount > 0 || usage.teachingBlocksCount > 0 || usage.lessonUnitsCount > 0,
  );
  if (!used) {
    return null;
  }

  const { data: lessonsData } = await urqlClient
    .query<SubjectContainerUsedInLessonsQuery, SubjectContainerUsedInLessonsQueryVariables>(
      SubjectContainerUsedInLessonsDocument,
      { uuid: used.uuid },
      { requestPolicy: 'network-only' },
    )
    .toPromise();

  return {
    uuid: used.uuid,
    name: used.name,
    teachingBlocksCount: used.teachingBlocksCount,
    lessonUnitsCount: used.lessonUnitsCount,
    lessons: lessonsData?.lessonsForSubjectContainer ?? [],
  };
};
